export const BARLOW_FONT = 'Barlow Semi Condensed Semibold';
export const FIGTREE_FONT = 'Figtree';
export const NOTO_FONT =
  'Noto Sans, Noto Sans Math, Noto Sans Arabic, Noto Sans Armenian, Noto Sans Bengali, Noto Sans SC, Noto Sans TC, Noto Sans Devanagari, Noto Sans Georgian, Noto Sans Hebrew, Noto Sans JP, Noto Sans Kannada, Noto Sans Khmer, Noto Sans KR, Noto Sans Myanmar, Noto Sans Sinhala, Noto Sans Tamil, Noto Sans Telugu, Noto Sans Thai, Noto Sans Thaana';

// Create a font stack
export const createFontStack = (font: string, fallback: string) => {
  return [font, fallback, 'sans-serif'].join(', ');
};
